import { render, staticRenderFns } from "./PositionDepartmentDetailTable.vue?vue&type=template&id=6ce124a4&scoped=true&"
import script from "./PositionDepartmentDetailTable.vue?vue&type=script&lang=js&"
export * from "./PositionDepartmentDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./PositionDepartmentDetailTable.vue?vue&type=style&index=0&id=6ce124a4&lang=scss&scoped=true&"
import style1 from "./PositionDepartmentDetailTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce124a4",
  null
  
)

export default component.exports